import React, { useEffect, useRef } from 'react';
import { useConf } from '../../lib/hooks';
import Icon from '../ds/Icon';
import { LogoMark } from '../ds/LogoMark';

// Sign-in popup — the OAuth provider buttons in an accessible dialog.
// Clicking a provider does a full navigation to /auth/<provider> (server OAuth);
// the callback (?code) is still handled by the /login route.
export const LoginModal = ({ open, onClose }) => {
    const { loginButtons } = useConf();
    const dialogRef = useRef(null);

    useEffect(() => {
        if (!open) {
            return undefined;
        }
        const prevFocus = document.activeElement;
        const onKey = (e) => { if (e.key === 'Escape') onClose(); };
        document.addEventListener('keydown', onKey);
        dialogRef.current?.focus();
        return () => {
            document.removeEventListener('keydown', onKey);
            if (prevFocus && typeof prevFocus.focus === 'function') prevFocus.focus();
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [open]);

    if (!open) {
        return null;
    }
    return (
        <div className="ds-scope ds-modal is-open" onMouseDown={(e) => { if (e.target === e.currentTarget) onClose(); }}>
            <div ref={dialogRef} tabIndex={-1} role="dialog" aria-modal="true" aria-label="Sign in"
                className="ds-modal__dialog" style={{ maxWidth: '420px', textAlign: 'center' }}>
                <button type="button" className="ds-btn is-ghost is-icon ds-modal__close" aria-label="Close" onClick={onClose}>
                    <Icon name="close" />
                </button>
                <div style={{ margin: '0 auto var(--ds-space-4)', width: 56 }}><LogoMark size={56} /></div>
                <h3 style={{ marginBottom: 'var(--ds-space-1)' }}>Welcome to Focuz</h3>
                <p style={{ color: 'var(--ds-ink-muted)', marginBottom: 'var(--ds-space-6)' }}>Sign in to your dashboard</p>
                <div style={{ display: 'grid', gap: 'var(--ds-space-3)' }}>
                    {loginButtons.map(item => (
                        <a key={item.value} className={`ds-btn is-primary is-block btn-${item.value}`} href={`/auth/${item.value}`}>
                            {item.name}
                        </a>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default LoginModal;
